module.exports = __webpack_public_path__ + "img/sophos.72b274df.png";